import { render } from "./ClientCreatePage.vue?vue&type=template&id=6e9d4e34"
import script from "./ClientCreatePage.vue?vue&type=script&lang=js"
export * from "./ClientCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__